<section class="mx-auto max-w-[1100px] px-6 py-9 sm:px-8 lg:px-0">
  <div class="mb-6 flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between sm:gap-6">
    <div class="max-w-2xl">
      <div class="mb-3 flex h-1.5 w-[30px] gap-1">
        <span class="flex-1 rounded bg-(--cmr-vert)"></span>
        <span class="flex-1 rounded bg-(--cmr-rouge)"></span>
        <span class="flex-1 rounded bg-(--cmr-jaune)"></span>
      </div>
      <div class="text-[11px] font-bold uppercase tracking-[0.12em] text-slate-500">{{ 'pages.successStories.eyebrow' | translate }}</div>
      <h1 class="mt-2 text-3xl font-extrabold leading-tight text-(--text-body) sm:text-4xl">{{ 'pages.successStories.title' | translate }}</h1>
    </div>

    <button type="button" (click)="proposeStory()"
      class="inline-flex items-center justify-center gap-2 rounded-sm border border-(--brand-primary) bg-transparent px-5 py-3 text-sm font-bold text-(--brand-primary) transition hover:bg-(--brand-primary)/10 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(--brand-primary)">
      {{ 'pages.successStories.proposeMine' | translate }}
    </button>
  </div>

  @if (regionOptions().length > 0) {
    <div class="mb-6 flex flex-wrap gap-2">
      <button type="button" (click)="setRegionFilter('')"
        class="inline-flex items-center gap-2 rounded-full border px-3 py-2 text-sm font-semibold transition"
        [class]="!regionFilter() ? 'border-(--brand-primary) bg-(--brand-primary) text-white' : 'border-(--border-strong) bg-white text-(--text-body) hover:bg-(--gris-050)'">
        {{ 'opportunities.allRegions' | translate }}
      </button>
      @for (code of regionOptions(); track code) {
        <button type="button" (click)="setRegionFilter(code)"
          class="inline-flex items-center gap-2 rounded-full border px-3 py-2 text-sm font-semibold transition"
          [class]="regionFilter() === code ? 'border-(--brand-primary) bg-(--brand-primary) text-white' : 'border-(--border-strong) bg-white text-(--text-body) hover:bg-(--gris-050)'">
          {{ ('regions.' + code) | translate }}
        </button>
      }
    </div>
  }

  @if (loading()) {
    <p class="py-12 text-center text-[13.5px] text-(--text-muted)" aria-live="polite">{{ 'common.loading' | translate }}</p>
  } @else if (error()) {
    <p class="py-12 text-center text-[13.5px] text-(--state-danger)" role="alert">
      {{ 'pages.successStories.loadError' | translate }}
    </p>
  } @else if (filteredStories().length > 0) {
    <div class="grid gap-4 sm:grid-cols-[repeat(auto-fill,minmax(300px,1fr))]">
      @for (story of filteredStories(); track story.id; let i = $index) {
        <a [appScrollReveal]="i" [routerLink]="['/success-stories', story.slug]"
          class="group overflow-hidden rounded-2xl border border-(--border-subtle) bg-white shadow-card transition hover:-translate-y-1 hover:shadow-(--shadow-raised)">
          <article>
            <div class="flex h-48 items-end overflow-hidden bg-(--pnud-bleu) bg-cover bg-center p-4 text-sm text-white/70 transition-transform duration-500 ease-out group-hover:scale-110"
              [style.background-image]="story.imageUrl ? 'url(' + story.imageUrl + ')' : null">
              @if (!story.imageUrl) {
                {{ story.categoryLabelKey | translate }}
              }
            </div>
            <div class="space-y-3 p-5">
              <span class="inline-flex rounded-full px-3 py-1 text-[13px] font-bold"
                [class]="story.categoryTextClass + ' bg-(--surface-primary-tint)'">{{ story.categoryLabelKey | translate }}</span>
              <h2 class="text-[16px] font-extrabold leading-tight text-(--text-body)">{{ story.title }}</h2>
              @if (story.summary) {
                <p class="text-sm leading-6 text-slate-600">{{ story.summary }}</p>
              }
              @if (story.publishedAt) {
                <div class="text-[12.5px] text-(--text-muted)">{{ story.publishedAt | localizedDate }}</div>
              }
            </div>
          </article>
        </a>
      }
    </div>
  } @else {
    <div class="box-border rounded-md border border-(--border-subtle) bg-white px-6 py-12 text-center">
      <p class="m-0 text-[14px] text-(--text-muted)">{{ 'pages.successStories.empty' | translate }}</p>
    </div>
  }
</section>
